__turbopack_context__.v({
  "close": "tour-modal-module-scss-module__70E4Ga__close",
  "dialog": "tour-modal-module-scss-module__70E4Ga__dialog",
  "dialogCompact": "tour-modal-module-scss-module__70E4Ga__dialogCompact",
  "wrap": "tour-modal-module-scss-module__70E4Ga__wrap",
  "wrapCompact": "tour-modal-module-scss-module__70E4Ga__wrapCompact",
});
